// extracted by mini-css-extract-plugin
export default {"formPage":"FormPage_formPage__UySNB"};